import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CloseCircleOutlined } from '@ant-design/icons';

const PaperPaymentFailPage: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const code = searchParams.get('code');
  const message = searchParams.get('message');

  return (
    <div style={{ maxWidth: '600px', margin: '80px auto', padding: '40px', textAlign: 'center' }}>
      <CloseCircleOutlined style={{ fontSize: '64px', color: '#ff4d4f', marginBottom: '24px' }} />
      <h2 style={{ marginBottom: '16px' }}>결제에 실패했습니다</h2>
      
      {message && (
        <div style={{ padding: '24px', background: '#fff2e8', borderRadius: '8px', marginBottom: '32px' }}>
          <div style={{ color: '#ff4d4f', marginBottom: '8px' }}>
            <strong>오류 코드:</strong> {code || '알 수 없음'}
          </div>
          <div style={{ color: '#666' }}>
            <strong>오류 메시지:</strong> {decodeURIComponent(message)}
          </div>
        </div>
      )}

      <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
        <button
          onClick={() => navigate('/academy/paper/list')}
          style={{
            padding: '12px 24px',
            background: '#1890ff',
            color: '#fff',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '16px'
          }}
        >
          시험지 목록으로
        </button>
      </div>
    </div>
  );
};

export default PaperPaymentFailPage;

